import React, { Component } from "react";
import { connect } from "react-redux";
import { isValidIBAN } from "ibantools";
import xss from "xss";

import { connectForm, Form } from "../utils/components/form";
import PERSONART from "../utils/enums/PERSONART";
import { dateDiff } from "../utils/functions";
import { InputPersonArt, InputField, InputGebietsansaessiger, InputNationalitaet } from './components';

class KundenFormMA extends Component {
  constructor(props) {
    super(props);
    this.validPersonart = this.validPersonart.bind(this);
    this.validEmail = this.validEmail.bind(this);
    this.validIban = this.validIban.bind(this);
    this.doChangePersonArt = this.doChangePersonArt.bind(this);
  }

  state = {
    personArt: null,
    displayFields: false,
    isCompany: false,
  };

  labelClass = "col-12 col-md-5 col-lg-4 text-gray d-flex align-self-center flex-wrap fs-4";
  inputClass = "col-12 col-md-7 col-lg-8";

  componentDidUpdate() {
    if (!this.state.edit && this.props.edit) {
      this.setState({ edit: this.props.edit, personArt: this.props.kundenStorage.kunde.personArt });
      this.doChangePersonArt(this.props.kundenStorage.kunde.personArt);
    }
  }

  componentDidMount() {
    if (typeof this.props.initialize === "function") {
      this.props.initialize(this.props.initialValues);
    }
    if (this.props.edit) {
      this.setState({ edit: this.props.edit, personArt: this.props.kundenStorage.kunde.personArt });
      this.doChangePersonArt(this.props.kundenStorage.kunde.personArt);
    }
  }

  resetFields = (formName, fieldsObj) => {
    Object.keys(fieldsObj).forEach(fieldKey => {
      if (this.form && this.form.getRegisteredFields().includes(fieldKey)) {
        // do it the react-final-form way
        this.form.change(fieldKey, fieldsObj[fieldKey]);
        this.form.resetFieldState(fieldKey);
      }
    });
  };

  doChangePersonArt(personArtValue) {
    let value = personArtValue;
    // check if comming from an event callback
    if (value && value.target && value.target.value) {
      value = xss(value.target.value);
    }
    // die Variable wird auf true gesetzt, wenn Änderung von Rechtsform betroffen ist
    let changed = false;
    if (this.state.personArt === null) this.setState({ personArt: value });
    switch (value) {
      case PERSONART.NATUERLICHE_PERSON.KUERZEL:
      case PERSONART.WIRTSCHAFTLICHE_PERSON.KUERZEL:
        if (this.state.personArt === PERSONART.JURISTISCHE_PERSON.KUERZEL) changed = true;
        break;
      default:
        if (this.state.personArt === null && this.props.edit) break;
        if (this.state.personArt !== value) changed = true;
    }
    if (this.props.edit || value) {
      if (value === PERSONART.JURISTISCHE_PERSON.KUERZEL) {
        this.setState({ personArt: value, isCompany: true, displayFields: true });
      } else {
        this.setState({ personArt: value, isCompany: false, displayFields: true });
      }
    } else {
      this.setState({ personArt: "", isCompany: false, displayFields: false });
    }
    if (changed) {
      this.resetFields("kundenDataForm", {
        nachname: "",
        vorname: "",
        nationalitaet: "",
        gebDatKunde: "",
        gebOrtKunde: ""
      });
    }
  }

  validPersonart(personart) {
    if (personart === "" && personart === null) {
      return "Bitte wählen sie eine Personart aus";
    }
    return undefined;
  }

  validEmail(email, values, props) {
    if (this.props.configStorage.isKundenShop() && !email) {
      return "Bitte tragen Sie eine E-Mail Adresse ein";
    } else if (email && !email.match(/^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@(([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{2,})$/i)) {
      return "Bitte tragen Sie eine gültige E-Mail Adresse ein";
    } else if (values.email !== values.email2) {
      return "Die Email-Adressen müssen übereinstimmen";
    }
    return undefined;
  }

  validIban(iban, values, props) {
    // do not check in kundenShop as IBAN is not editable
    if (values && !values.isMaShop) return undefined;
    if (!values.kundenkonto) return "Bitte tragen Sie eine IBAN ein.";
    const checkIban = String(values.kundenkonto).replace(/\s+/g, "");
    const blz = new RegExp("DE.." + this.props.configStorage.getBankId());
    if (!isValidIBAN(checkIban)) {
      return "Bitte tragen Sie eine gültige IBAN ein.";
    } else if (!String(checkIban).match(blz)) {
      return "Nur Konten des eigenen Instituts sind erlaubt.";
    } else {
      return undefined;
    }
  }

  render() {
    let nameCustomer = "Nachname";
    let nameCompany = "Firmenname inkl. Rechtsform";
    let isMaShop = this.props.configStorage.isMaShop();
    return (
      <Form onSubmit={this.props.onSubmit} {...this.props}>
        {props => {
          this.form = props.form;
          return (
            <div className="bootstrap-iso">
              <div className="row mb-1">
                <div className="col-12 col-md-12 col-lg-12">
                  <form
                    onSubmit={props.handleSubmit}
                    className="form-group"
                  >
                    <InputPersonArt
                      name="personArt"
                      label="Personenart"
                      required={true}
                      disabled={false}
                      labelClass={this.labelClass}
                      inputClass={this.inputClass}
                      validate={this.validPersonart}
                      onChange={isMaShop ? this.doChangePersonArt : null}
                    />
                    {this.state.displayFields
                      ? <div>
                        <InputField
                          name="nachname"
                          label={this.state.isCompany ? nameCompany : nameCustomer}
                          required={true}
                          disabled={!isMaShop}
                          placeholder={this.state.isCompany ? nameCompany : nameCustomer}
                          labelClass={this.labelClass}
                          inputClass={this.inputClass}
                        />
                        {!this.state.isCompany
                          ? <InputField
                            name="vorname"
                            label="Vorname"
                            required={true}
                            disabled={!isMaShop}
                            placeholder={"Vorname/n"}
                            labelClass={this.labelClass}
                            inputClass={this.inputClass}
                          />
                          : null
                        }
                        <InputField
                          name="strasse1"
                          label="Strasse 1"
                          required={true}
                          disabled={!isMaShop}
                          placeholder={"Straße und Hausnummer"}
                          labelClass={this.labelClass}
                          inputClass={this.inputClass}
                        />
                        <InputField
                          name="strasse2"
                          label="Strasse 2"
                          required={false}
                          disabled={!isMaShop}
                          placeholder={"Straße und Hausnummer"}
                          labelClass={this.labelClass}
                          inputClass={this.inputClass}
                        />
                        <InputField
                          name="plz"
                          label="PLZ"
                          required={true}
                          disabled={!isMaShop}
                          placeholder={"PLZ"}
                          maxLength={5}
                          labelClass={this.labelClass}
                          inputClass={this.inputClass}
                        />
                        <InputField
                          name="ort"
                          label="Ort"
                          required={true}
                          disabled={!isMaShop}
                          placeholder={"Ort"}
                          labelClass={this.labelClass}
                          inputClass={this.inputClass}
                        />
                        <InputField
                          name="email"
                          label="Email"
                          required={this.props.configStorage.isKundenShop()}
                          disabled={false}
                          validate={this.validEmail}
                          placeholder={"Email"}
                          labelClass={this.labelClass}
                          inputClass={this.inputClass}
                        />
                        <InputField
                          name="email2"
                          label="Email zur Bestätigung"
                          required={this.props.configStorage.isKundenShop()}
                          disabled={false}
                          validate={this.validEmail}
                          placeholder={"Email"}
                          labelClass={this.labelClass}
                          inputClass={this.inputClass}
                        />
                        <InputField
                          name="kundenkonto"
                          label="IBAN"
                          required={true}
                          disabled={!isMaShop}
                          validate={this.validIban}
                          beschreibung="(ohne Leerzeichen)"
                          placeholder={"IBAN (ohne Leerzeichen)"}
                          labelClass={this.labelClass}
                          inputClass={this.inputClass}
                        />
                        {!isMaShop || !this.state.isCompany
                          ? <div>
                            <InputNationalitaet
                              name="nationalitaet"
                              label="Nationalität"
                              required={!this.state.isCompany}
                              disabled={!isMaShop}
                              placeholder={"Nationalität"}
                              labelClass={this.labelClass}
                              inputClass={this.inputClass}
                            />
                            <InputField
                              name="gebDatKunde"
                              label="Geburtsdatum"
                              required={!this.state.isCompany}
                              disabled={!isMaShop}
                              placeholder={"Format: TT.MM.JJJJ"}
                              labelClass={this.labelClass}
                              inputClass={this.inputClass}
                            />
                            <InputField
                              name="gebOrtKunde"
                              label="Geburtsort"
                              required={!this.state.isCompany}
                              disabled={!isMaShop}
                              placeholder={"Geburtsort"}
                              labelClass={this.labelClass}
                              inputClass={this.inputClass}
                            />
                          </div>
                          : null
                        }
                        <InputGebietsansaessiger className="form-control form-control-lg"
                          name="gebietsansaessigKz"
                          label="Gebiets&shy;ansässiger"
                          required={true}
                          disabled={false}
                          labelClass={this.labelClass}
                          inputClass={this.inputClass}
                        />
                      </div>
                      : null
                    }
                    <div className="d-flex justify-content-end">
                      <button
                        className="btn btn-primary col-12 col-md-4 col-lg-3"
                        id="kunden_speicher"
                        disabled={props.invalid}
                      >
                        Speichern und Fortfahren
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          );
        }}
      </Form>
    );
  }
}

const validate = formValues => {
  const errors = {};
  const isCompany = formValues.personArt === PERSONART.JURISTISCHE_PERSON.KUERZEL;
  const isMaShop = formValues.isMaShop;
  if (!Object.keys(PERSONART).map(key => PERSONART[key].KUERZEL).includes(formValues.personArt)) {
    errors.personArt = "Bitte tragen Sie einen Wert ein.";
  } else {
    errors.personArt = undefined;
  }
  if (!formValues.nachname && isMaShop) {
    errors.nachname = "Bitte tragen Sie einen Wert ein.";
  } else {
    errors.nachname = undefined;
  }
  if (!formValues.vorname && !isCompany && isMaShop) {
    errors.vorname = "Bitte tragen Sie einen Wert ein.";
  } else {
    errors.vorname = undefined;
  }
  if (!formValues.strasse1 && isMaShop) {
    errors.strasse1 = "Bitte tragen Sie einen Wert ein.";
  } else if (formValues.strasse1 && formValues.strasse1.length > 32 && isMaShop) {
    errors.strasse1 = "Es dürfen max. 32 Zeichen sein.";
  } else {
    errors.strasse1 = undefined;
  }
  if (formValues.strasse2 !== undefined && formValues.strasse2 !== null && formValues.strasse2.length > 32 && isMaShop) {
    errors.strasse2 = "Es dürfen max. 32 Zeichen sein.";
  } else {
    errors.strasse2 = undefined;
  }
  if (!formValues.ort && isMaShop) {
    errors.ort = "Bitte tragen Sie einen Wert ein.";
  } else if (formValues.ort && formValues.ort.length > 32 && isMaShop) {
    errors.ort = "Es dürfen max. 32 Zeichen sein.";
  } else {
    errors.ort = undefined;
  }
  if (!formValues.plz && isMaShop) {
    errors.plz = "Bitte tragen Sie einen Wert ein.";
  } else if (
    (
      (formValues.plz && formValues.plz.length !== 5) ||
      !String(formValues.plz).match(/^\d{5}/)
    ) && isMaShop
  ) {
    errors.plz = "Bitte tragen Sie eine gültige Postleitzahl ein.";
  } else {
    errors.plz = undefined;
  }
  if (!formValues.nationalitaet && !isCompany) {
    errors.nationalitaet = "Bitte wählen Sie Ihre Nationalität aus.";
  } else {
    errors.nationalitaet = undefined;
  }
  const diff = dateDiff(new Date(String(formValues.gebDatKunde).replace(/^(\d{2})\.(\d{2})\.(\d{4})$/, "$3-$2-$1")), new Date());
  if (isCompany || !isMaShop) {
    errors.gebDatKunde = undefined;
  } else if (!formValues.gebDatKunde) {
    errors.gebDatKunde = "Bitte tragen Sie das Geburtsdatum in diesem Format ein: TT.MM.JJJJ";
  } else if (!formValues.gebDatKunde.match(/\d{2}\.\d{2}\.\d{4}/)) {
    errors.gebDatKunde = "Bitte tragen Sie das Geburtsdatum in diesem Format ein: TT.MM.JJJJ";
  } else if (isNaN(diff.years)) {
    errors.gebDatKunde = "Bitte tragen Sie ein gültiges Datum ein";
  } else if (diff.years < 14 || diff.years > 150) {
    errors.gebDatKunde = "Sie müssen geschäftsfähig sein";
  } else {
    errors.gebDatKunde = undefined;
  }
  if (!formValues.gebOrtKunde && !isCompany && isMaShop) {
    errors.gebOrtKunde = "Bitte tragen Sie einen Wert ein.";
  } else {
    errors.gebOrtKunde = undefined;
  }
  if (formValues.gebietsansaessigKz !== "0" && formValues.gebietsansaessigKz !== "1" && formValues.gebietsansaessigKz !== 0 && formValues.gebietsansaessigKz !== 1) {
    errors.gebietsansaessigKz = "Bitte wählen Sie die zutreffende Option aus.";
  } else {
    errors.gebietsansaessigKz = undefined;
  }
  return errors;
};

export default connectForm({
  form: "kundenDataForm",
  enableReinitialize: true,
  validate: validate
})(connect((store) => {
  return {
    configStorage: store.configStorage,
    kundenStorage: store.kundenStorage,
  };
})(KundenFormMA));
